export default __webpack_public_path__ + "static/media/visible thinking.b67073ef.svg";